import { createApi } from '@reduxjs/toolkit/query/react';

import {
  type PostOnCheckInDTO,
  type PostNotifyMembersAboutPatientDTO,
  type Room,
} from '../waitingRoom.types';
import { transformRoom } from '../helpers';
import { ogBaseQuery } from '../../ogBaseQuery';

export const waitingRoomOGService = createApi({
  baseQuery: ogBaseQuery(),
  reducerPath: 'waitingRoomOGReducerFromLibrary',
  endpoints: (builder) => ({
    getRoomBySlugOG: builder.query<
      Room,
      { roomSlug: string; institutionId?: number }
    >({
      query: (data) => {
        return {
          url: `rooms/slug/${data.roomSlug}`,
          method: 'GET',
          params: {
            institutionId: data.institutionId,
          },
        };
      },
      transformResponse: transformRoom,
    }),
    postOnCheckInOG: builder.mutation<
      undefined,
      { roomId: string; payload: PostOnCheckInDTO }
    >({
      query: (data) => {
        return {
          url: `rooms/${data.roomId}/onCheckIn`,
          method: 'POST',
          body: data.payload,
        };
      },
    }),
    postIsValidPasscode: builder.query<
      { isValid: boolean },
      { roomId: string; passcode: string }
    >({
      query: (data) => {
        return {
          url: `rooms/${data.roomId}/isValidPasscode`,
          method: 'POST',
          body: { passcode: data.passcode },
        };
      },
    }),
    postNotifyMembersAboutPatientOG: builder.mutation<
      undefined,
      { roomId: string; payload: PostNotifyMembersAboutPatientDTO }
    >({
      query: (data) => {
        return {
          url: `rooms/${data.roomId}/notifyMembersAboutPatient`,
          method: 'POST',
          body: data.payload,
        };
      },
    }),
    getIsUniqueRoomBySlug: builder.query<
      boolean,
      { roomSlug: string; institutionId?: number }
    >({
      query: (data) => ({
        url: `rooms/isUnique`,
        method: 'GET',
        params: {
          slug: data.roomSlug,
          institutionId: data.institutionId,
        },
      }),
      transformResponse: (data: { isUnique: boolean }) => data.isUnique,
    }),
  }),
});

export const {
  useGetRoomBySlugOGQuery,
  useLazyGetRoomBySlugOGQuery,
  usePostOnCheckInOGMutation,
  usePostNotifyMembersAboutPatientOGMutation,
  usePostIsValidPasscodeQuery,
  useLazyPostIsValidPasscodeQuery,
  useLazyGetIsUniqueRoomBySlugQuery,
} = waitingRoomOGService;
